import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { MsalProvider } from '@azure/msal-react';
import AppRouter from './AppRouter';
import {
    ErrorBoundary,
    FileViewerModal,
    FloatingChatElement,
    Loader,
    SessionPopup,
} from './components/shared';
import { ROLES } from './constants';
import { CustomerChatElement } from './components/Customer/CustomerChatElement';
import useSocket from './hooks/useSocket';
import SessionCountdownToast from './components/shared/Popovers/SessionCountdownToast';
import AiAssistantWidget from './components/shared/AiAssistantWidget';

function App({ instance }) {
    // isLoaderRequired is false by default
    const isLoaderRequired = useSelector((state) => state.loader.loader);
    const openFileViewerModal = useSelector((state) => state.fileViewerModal.openFileViewerModal);
    const isDarkMode = useSelector((state) => state.theme.isDarkMode);
    const isCSMCaseload = useSelector((s) => s.csmCaseload?.isCsmCaseload);
    const role = useSelector((state) => state.user.role);
    useSocket()
    
    // Update the theme on state change
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
    }, [isDarkMode]);

    return (
        <MsalProvider instance={instance}>
            <ErrorBoundary>
                <AppRouter instance={instance} />
                {(role === ROLES.CSM || isCSMCaseload) && <FloatingChatElement />}
                {role === ROLES.USER && <CustomerChatElement />}
                {isLoaderRequired && <Loader />}
                {openFileViewerModal && <FileViewerModal />}
                <SessionPopup />
                <SessionCountdownToast />
                <AiAssistantWidget />
            </ErrorBoundary>
        </MsalProvider>
    );
}

export default App;
